var map = {
	"./Both.svg": "0abf",
	"./Chevron.svg": "a19c",
	"./Marker-sm.svg": "49df",
	"./calendar.svg": "76b2",
	"./circle-plus.svg": "9fa9",
	"./hologram.svg": "78b2",
	"./led-belt.svg": "d4b6",
	"./list.svg": "484a",
	"./loading.svg": "e96b",
	"./man-woman.svg": "e2f5",
	"./man.svg": "b947",
	"./pharmaflix-origin.svg": "36eb",
	"./pharmaflix.svg": "8cdf",
	"./play-button.svg": "d3b4",
	"./question-mark.svg": "c85d",
	"./screen.svg": "dd95",
	"./search.svg": "0a17",
	"./settings.svg": "bc64",
	"./smartphone.svg": "1662",
	"./smartphone_2.svg": "cfea",
	"./star-plus.svg": "0068",
	"./star.svg": "ec6f",
	"./trash-can.svg": "3f12",
	"./user.svg": "4d66",
	"./video-projector.svg": "23cb",
	"./video.svg": "2b54",
	"./women.svg": "abcd",
	"./x-mark.svg": "b0cd",
	"./zoom.svg": "7b3e"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "f166";
module.exports = webpackAsyncContext;